/** Selection arithmetic for a table: pure, so the shift-click rule has one home and a test. */

/** The keys from `anchor` to `target` inclusive, in the order the rows are shown. An anchor that is
 * not on the page (a filter removed its row) degrades to the target alone. */
export function rangeBetween(keys: readonly string[], anchor: string | null, target: string): string[] {
  const to = keys.indexOf(target);
  if (to < 0) return [];
  const from = anchor === null ? -1 : keys.indexOf(anchor);
  if (from < 0) return [target];
  const [lo, hi] = from <= to ? [from, to] : [to, from];
  return keys.slice(lo, hi + 1);
}

/** What a header tick-box shows: nothing, some or every row of the page. */
export function tickState(chosen: number, shown: number): "none" | "some" | "all" {
  if (shown === 0 || chosen === 0) return "none";
  return chosen >= shown ? "all" : "some";
}
